export default {
    title: "Heim",
    button: {
        accessories: "Katalog durchsuchen"
    },
    noAvailableItems: "Im Peripherieportal sind derzeit keine Artikel für Ihr Land verfügbar. Bitte arbeiten Sie mit Ihrem Vorgesetzten zusammen, um die benötigten Artikel zu beschaffen.<br><br> <a href='#' role='button' data-widget-trigger='{widgetOptions}'>Kontaktieren Sie Support</a>",
    error: "Beim Abrufen der Produkte ist ein Problem aufgetreten. Bitte aktualisiere deinen Browser."
}